import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const LanguageRow = ({ label, languages, color = 'default' }) => (
  <Box mb={2}>
    <Typography variant="subtitle2">{label}</Typography>
    <Box mt={1}>
      {languages.length ? (
        languages.map(language => (
          <Box key={language} component="span" mr={1}>
            <Chip label={language} color={color} size="small" />
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="textSecondary">
          —
        </Typography>
      )}
    </Box>
  </Box>
);

LanguageRow.propTypes = {
  label: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
};

LanguageRow.defaultProps = {
  color: 'default',
};

const LanguageStatus = ({ status }) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  return (
    <Box>
      <LanguageRow
        label={t('trainingParts.lmsLanguages.applicableContentLanguages', 'Company content languages')}
        languages={status.applicableLanguages || []}
      />
      <LanguageRow
        label={t('trainingParts.lmsLanguages.synchronizedLmsLanguages', 'Available in LMS')}
        languages={status.synchronizedLanguages || []}
        color="primary"
      />
      {(status.missingLanguages || []).length > 0 && (
        <LanguageRow
          label={t('trainingParts.lmsLanguages.missingLmsLanguages', 'Missing from LMS')}
          languages={status.missingLanguages}
          color="secondary"
        />
      )}
      {(status.retainedLanguages || []).length > 0 && (
        <LanguageRow
          label={t('trainingParts.lmsLanguages.retainedLmsLanguages', 'Retained, no longer assigned')}
          languages={status.retainedLanguages}
        />
      )}
    </Box>
  );
};

LanguageStatus.propTypes = {
  status: PropTypes.shape({
    applicableLanguages: PropTypes.arrayOf(PropTypes.string),
    synchronizedLanguages: PropTypes.arrayOf(PropTypes.string),
    missingLanguages: PropTypes.arrayOf(PropTypes.string),
    retainedLanguages: PropTypes.arrayOf(PropTypes.string),
  }),
};

LanguageStatus.defaultProps = {
  status: null,
};

export default LanguageStatus;
